import classnames from 'classnames'
import React from 'react'

import Button, { BUTTON_SIZE, BUTTON_TYPES } from '../../button'
import Link from '../../link'
import { SiblingProductOptionType } from '../SiblingProductOptions'

import styles from './SiblingProductButton.module.scss'

interface SiblingProductButtonProps {
  value: string
  displayName: string
  isActive: boolean
  variant: SiblingProductOptionType
  onClickCallback?: (val: string) => void
  className?: string
  id?: string
  showNewPdpDesignV2?: boolean
}

function SiblingProductButton({
  variant,
  value,
  displayName,
  isActive,
  onClickCallback,
  className,
  id,
  showNewPdpDesignV2,
}: SiblingProductButtonProps) {
  const activeClassName = isActive
    ? showNewPdpDesignV2
      ? styles.option__selected_newDesignV2
      : styles.option__selected
    : ''
  return variant === SiblingProductOptionType.LINK ? (
    <Link
      id={id}
      href={value}
      onClick={onClickCallback}
      className={classnames(styles.option, className, activeClassName)}
    >
      {displayName || value}
    </Link>
  ) : (
    <Button
      id={id}
      type={BUTTON_TYPES.OUTLINED}
      size={BUTTON_SIZE.MEDIUM}
      round={false}
      className={classnames(styles.option, className, activeClassName)}
      onClick={() => {
        !isActive && onClickCallback?.(value)
      }}
    >
      {displayName || value}
    </Button>
  )
}

export default SiblingProductButton
